// extracted by mini-css-extract-plugin
module.exports = {"modal":"diffmodalmulti_modal__1COCQ","tableWrapper":"diffmodalmulti_tableWrapper__3DLRQ","diffCell":"diffmodalmulti_diffCell__3o11t"};